import { Autocomplete, CircularProgress, FormControl, TextField } from "@mui/material";
import { observer } from "mobx-react-lite";
import { RBDType } from "../../app/config/enum";
import { IEquipment } from "../../app/models/asset";
import { useStore } from "../../app/stores/store";

function RBDSettingEquipment() {
    const { rbdStore } = useStore();

    const handleChange = (value: IEquipment | null) => {
        rbdStore.setSelectedEquipment(value)
    }

    return (
        <FormControl fullWidth sx={{ mb: 4 }}>
            <Autocomplete
                options={rbdStore.dropdownEquipment}
                renderInput={(params) =>
                    <TextField {...params} label="Equipment" InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {rbdStore.loadingEquipment ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }} />
                }
                getOptionDisabled={(option) => (
                    rbdStore.selectedRbdType === RBDType.SYSTEM &&
                    rbdStore.rbdItems.map(x => x.element?.equipmentId).indexOf(option.id) >= 0
                )}
                getOptionLabel={(equipment) => equipment.tagNumber}
                renderOption={(props, option) => 
                    <li {...props} key={option.id}>
                        {option.tagNumber}
                    </li>
                }
                value={rbdStore.selectedEquipment}
                onChange={(e, val) => handleChange(val)}
                loading={rbdStore.loadingEquipment}
            />
        </FormControl>
    );
}

export default observer(RBDSettingEquipment);